// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"23949c1f","178":"55ba029c","538":"47e69869","901":"dbe9a8ef","912":"9f52c0c8","990":"d13f16b3","996":"a1ceb66f"}[chunkId] + ".chunk.js";
};